"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTitleForChart = void 0;
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const Measure_1 = require("@opsbase/lib-chart/Measure");
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const TimeInterval_1 = require("@opsbase/lib-time/TimeInterval");
function calcTitleForChart(query, chart) {
    var _a, _b, _c, _d, _e;
    switch (chart.chartVariant) {
        case ChartVariant_1.default.COUNT_GROUP:
            return (0, getFromStringOrFunction_1.getFromStringOrFunction)((_a = QueryFieldRegistry_1.default[chart.config.dimension]) === null || _a === void 0 ? void 0 : _a.label);
        case ChartVariant_1.default.COUNT_TIME:
            return (0, getFromStringOrFunction_1.getFromStringOrFunction)((_b = QueryFieldRegistry_1.default[chart.config.timeDimension]) === null || _b === void 0 ? void 0 : _b.label);
        case ChartVariant_1.default.COUNT_GROUP_TIME:
            return ((0, getFromStringOrFunction_1.getFromStringOrFunction)((_c = QueryFieldRegistry_1.default[chart.config.otherDimension]) === null || _c === void 0 ? void 0 : _c.label) +
                ' / ' +
                (0, getFromStringOrFunction_1.getFromStringOrFunction)((_d = QueryFieldRegistry_1.default[chart.config.timeDimension]) === null || _d === void 0 ? void 0 : _d.label));
        case ChartVariant_1.default.SCORE_Q_OP:
            return ((_e = chart === null || chart === void 0 ? void 0 : chart.config) === null || _e === void 0 ? void 0 : _e.inverse) ? 'Points Missed' : 'Points Scored';
        case ChartVariant_1.default.PERF_GROUP_TIME:
            return ((0, Measure_1.measureLabel)(chart.config.measure) +
                ' / ' +
                dimensionToStr(chart.config.dimension) +
                ' / ' +
                (0, TimeInterval_1.timeIntervalLabel)(chart.config.interval));
    }
    return '';
}
exports.calcTitleForChart = calcTitleForChart;
exports.default = calcTitleForChart;
function dimensionToStr(v) {
    switch (v) {
        case QueryFieldKey_1.default.PLACE:
            return lib_i18n_1.default.t('place');
        case QueryFieldKey_1.default.OPDEFINITION:
            return lib_i18n_1.default.t('operation');
    }
}
